import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';  
import AppRoutes from "./components/Routes.jsx";   
import Header from "./components/component/Header.jsx";
import Sidebar from "./components/component/Navbar.jsx";
import TenantGate from "./components/component/TenantGate.jsx";

const App = () => {
    return (
        <Router>
            <a className="skip-link" href="#main-content">Skip to main content</a>
            <TenantGate>
              <div className="app-shell d-flex">
                      <Sidebar />
                  <div className="app-content">
                      <Header />
                      <main id="main-content" role="main" tabIndex="-1">
                      <AppRoutes />
                      </main>
                  </div>
              </div>
            </TenantGate>
        </Router>
    );
};

export default App;
